import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { useMemo, useState } from 'react';
import type { UsageUserRow } from './types';

const formatDate = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('is-IS');
};

const ClinicUsageUserTable = ({ users }: { users: UsageUserRow[] }) => {
  const [desc, setDesc] = useState(true);
  const sorted = useMemo(
    () => [...users].sort((a, b) => (desc ? b.sessions - a.sessions : a.sessions - b.sessions)),
    [users, desc]
  );

  if (users.length === 0) {
    return <p className="text-muted-foreground text-sm">Engin notkun á þessu tímabili.</p>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Notandi</TableHead>
          <TableHead>
            <button type="button" onClick={() => setDesc((v) => !v)} className="whitespace-nowrap font-medium">
              Lotur {desc ? '↓' : '↑'}
            </button>
          </TableHead>
          <TableHead>Síðast virk(ur)</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sorted.map((u, i) => (
          <TableRow key={`${u.name}-${u.last_active}-${i}`}>
            <TableCell>{u.name}</TableCell>
            <TableCell>{u.sessions}</TableCell>
            <TableCell>{formatDate(u.last_active)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ClinicUsageUserTable;
